<script setup>
const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  path: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: false,
  },

  type: {
    type: String,
    default: "primary",
    validator: (value) => {
      return ["primary", "secondary"].includes(value);
    },
  },
});
</script>
<template>
  <NuxtLink
    :to="path"
    class="group"
    :class="{
      'iq-cta': type === 'primary',
      'iq-cta-secondary': type === 'secondary',
    }"
  >
    <span>{{ label }}</span>
    <Icon
      v-if="icon"
      :name="icon"
      class="text-2xl transition-transform group-hover:translate-x-0.5"
    />
  </NuxtLink>
</template>
